var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/_Promise.js
 ** module id = 1563
 ** module chunks = 0
 **/